"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Analytics = Analytics;
var _utils = require("@whitbread-eos/utils");
var _format = _interopRequireDefault(require("date-fns/format"));
var _script = _interopRequireDefault(require("next/script"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function Analytics(_ref) {
  var {
    userDetails
  } = _ref;
  var {
    language
  } = (0, _utils.useGetCountryLanguage)();
  (0, _react.useEffect)(() => {
    var _userDetails$companyI, _userDetails$business, _userDetails$business2, _userDetails$business3, _userDetails$business4;
    _utils.analytics.update({
      language,
      browserTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      environment: process.env.NODE_ENV === 'development' ? 'development' : 'production',
      companyID: (_userDetails$companyI = userDetails === null || userDetails === void 0 ? void 0 : userDetails.companyId) !== null && _userDetails$companyI !== void 0 ? _userDetails$companyI : '',
      userID: (_userDetails$business = userDetails === null || userDetails === void 0 || (_userDetails$business2 = userDetails.business) === null || _userDetails$business2 === void 0 ? void 0 : _userDetails$business2.employeeId) !== null && _userDetails$business !== void 0 ? _userDetails$business : '',
      userLevel: (_userDetails$business3 = userDetails === null || userDetails === void 0 || (_userDetails$business4 = userDetails.business) === null || _userDetails$business4 === void 0 ? void 0 : _userDetails$business4.accessLevel) !== null && _userDetails$business3 !== void 0 ? _userDetails$business3 : '',
      userLoggedIn: userDetails ? 'Logged In' : 'Not Logged In',
      currentTime: (0, _format.default)(new Date(), 'HH:mm'),
      currencyCode: language === 'en' ? 'gbp' : 'eur',
      pageName: 'InnBusiness',
      pageType: 'look to book',
      pageURL: window.location.href
    });
  }, []);
  return (0, _jsxRuntime.jsx)(_script.default, {
    src: "//assets.adobedtm.com/launch-EN1f330bc46c5949b29c22bbf3f0573f75.min.js",
    strategy: "beforeInteractive",
    "data-testid": "adobe-script"
  });
}